import { internal_cloneResource } from '../../resource/resource.internal.mjs';

//
/**
 * @hidden
 *
 * Internal function that attaches an ACR to a Resource. Prefer using this than
 * setting the internal values manually (easier to refactor when changing the internals).
 */
function setAcr(resource, acr) {
    return Object.assign(internal_cloneResource(resource), {
        internal_acp: {
            acr,
        },
    });
}

export { setAcr };
